/* eslint-disable react/jsx-no-useless-fragment */
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useLookupCashCenters } from "../../services/lookups-queries";
import FormInput from "../../components/forms/form-Input";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import { useAddAssets } from "../../services/assets";
import Remarks from "../../components/forms/remarks";
import { formDefaultValues } from "./constants";

export default function AddAssets() {
  const params = useParams();
  const {
    mutate: createRequest,
    // isSuccess: isRequestCreated,
    // data: createRequestResponse,
    isPending: creatingRequest,
    // error: createError,
  } = useAddAssets();
  const {
    data: cashCenterListRes,
    isPending: gettingCashCenterList,
    // error: cashCenterError,
  } = useLookupCashCenters();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { ...formDefaultValues },
  });
  const formValidationRules = {
    cashCenterId: {},
    officeId: {},
    description: {},
    assetType: {},
    assetNo: {},
    serialNo: {},
    model: {},
    brand: {},
    status: {},
    remarks: {},
  };
  const generalFieldProps = { errors, control };

  const onSubmit = (data) => {
    const _payload = {
      cashCenterId: data.cashCenter?.cashCenterId,
      officeId: data.office?.officeId,
      description: data.description,
      assetType: data.assetType,
      assetNo: data.assetNo,
      serialNo: data.serialNo,
      model: data.model,
      brand: data.brand,
      status: data.status,
      remarks: data.remarks,
    };
    createRequest(_payload);
  };

  return (
    <>
      {creatingRequest || gettingCashCenterList ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Assets", link: Paths.assets },
            {
              text: params.userId ? "Edit Asset" : "Create Asset",
              isCurrentPage: true,
            },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Heading>Add Asset</Heading>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="add-location-form"
              >
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Cash Center"
                  name="cashCenterId"
                  id="cashCenterId"
                  text="name"
                  placeholder="Select Cash Center"
                  data={cashCenterListRes?.data || []}
                  rules={formValidationRules.cashCenterId}
                  filterable
                />

                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Office"
                  name="officeId"
                  rules={formValidationRules.officeId}
                />

                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Asset Type"
                  name="assetType"
                  rules={formValidationRules.assetType}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Asset Number"
                  name="assetNo"
                  rules={formValidationRules.assetNo}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Serial Number"
                  name="serialNo"
                  rules={formValidationRules.serialNo}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Model"
                  name="model"
                  rules={formValidationRules.model}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Brand"
                  name="brand"
                  rules={formValidationRules.brand}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Status"
                  name="status"
                  rules={formValidationRules.status}
                />
                <FormInput
                  {...generalFieldProps}
                  formControlProps={{ width: "100%" }}
                  isRequired
                  label="Description"
                  name="description"
                  rules={formValidationRules.description}
                />
                <div style={{ width: "100%" }} />
                <Remarks
                  formControlStyles={{ width: "100%" }}
                  {...generalFieldProps}
                  rows={2}
                />
                <Flex w="100%" justify="flex-end" flexDirection="row">
                  <Button type="submit">Submit</Button>
                </Flex>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
